import Image from '../Image';

const ModalCard = ({image, title, subtitle, description}) => {
  
  return (
    <div className="ModalCard">
        <div className="container-fluid">
            <div className="row align-items-center">
                <div className="col-auto px-0 thumb">
                    <Image image={image} title={title} />
                </div>
                <div className="col">
                    <div className="content">
                        <h2 dangerouslySetInnerHTML={{ __html: title }} />
                        <h3 dangerouslySetInnerHTML={{ __html: subtitle }} />
                        <hr />
                        <div dangerouslySetInnerHTML={{ __html: description }} />
                    </div>
                    <div className="topDegrade"></div>
                    <div className="bottomDegrade"></div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default ModalCard;
